// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import FlightInfo from "./FlightInfo-APP_CLIENT";

export default FlightInfo;
